import Text4 from './Text4'
export default Text4
